import React from "react";
import { Typography } from "@mui/material";

import { formatRevisionSaveDate } from "../../utils/revisionSaveStamp";

// The "saved by / saved at" lines that sit under the Rev. picker in the AMS
// module headers (PV, Piping, Structural). Renders nothing for a revision that
// carries no stamp - one that has never been saved, or was last saved before
// the stamp existed.
function RevisionSaveStamp({ stamp, maxWidth = 160 }) {
  if (!stamp) return null;

  const savedAt = formatRevisionSaveDate(stamp.savedAt);
  if (!stamp.savedBy && !savedAt) return null;

  const title = [stamp.savedBy, savedAt].filter(Boolean).join(" — ");

  const lineSx = {
    display: "block",
    maxWidth,
    lineHeight: 1.25,
    fontSize: 10.5,
  };

  return (
    <>
      {stamp.savedBy && (
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          title={title}
          sx={{ ...lineSx, fontWeight: 600 }}
        >
          {stamp.savedBy}
        </Typography>
      )}
      {savedAt && (
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          title={title}
          sx={lineSx}
        >
          {savedAt}
        </Typography>
      )}
    </>
  );
}

export default RevisionSaveStamp;
